import { render, staticRenderFns } from "./ListTable.vue?vue&type=template&id=23b5dfe7&scoped=true&"
import script from "./ListTable.vue?vue&type=script&lang=js&"
export * from "./ListTable.vue?vue&type=script&lang=js&"
import style0 from "./ListTable.vue?vue&type=style&index=0&id=23b5dfe7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b5dfe7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23b5dfe7')) {
      api.createRecord('23b5dfe7', component.options)
    } else {
      api.reload('23b5dfe7', component.options)
    }
    module.hot.accept("./ListTable.vue?vue&type=template&id=23b5dfe7&scoped=true&", function () {
      api.rerender('23b5dfe7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/dynamicViews/ListTable.vue"
export default component.exports